/**
 * Modal for selecting a team when recording a match from coach view
 * Shows when coach clicks "Record Team Match" without an active team
 */
export default function TeamSelectionModal({ teams, onSelectTeam, onClose }) {
  // Safety check for teams data
  const validTeams = Array.isArray(teams) ? teams : [];

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <div className="modal-title">Select Team</div>

        <div className="modal-message">
          <p style={{ marginBottom: '20px', color: 'var(--muted)' }}>
            Which team would you like to record a match for?
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {validTeams.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                No teams found. Please create a team first.
              </div>
            ) : (
              validTeams.map((team) => (
                <button
                  key={team.id}
                  onClick={() => onSelectTeam(team.id)}
                  style={{
                    textAlign: 'left',
                    padding: '16px',
                    background: 'white',
                    border: '1px solid var(--border)',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    width: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#F9FAFB';
                    e.currentTarget.style.borderColor = 'var(--primary)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'white';
                    e.currentTarget.style.borderColor = 'var(--border)';
                  }}
                >
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>
                    {team.name || team.teamName}
                  </div>
                </button>
              ))
            )}
          </div>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={onClose}
            className="btn btn-primary"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
